import { Component, Input, OnInit } from "@angular/core";
import {
  DEEventEmitterBo,
} from "./client-employee-dynamicform.model";
import { GlobalComponent } from "src/app/global/global.component";
@Component({
  selector: "app-client-employee-dynamicform",
  templateUrl: "./client-employee-dynamicform.component.html",
  styleUrls: ["./client-employee-dynamicform.component.scss"],
})
export class ClientEmployeeDynamicFormComponent implements OnInit {
  CEEditList: boolean = false;
  @Input() DynamicFormRelation;
  isListorEditView: DEEventEmitterBo = new DEEventEmitterBo();
  constructor(public global: GlobalComponent) { }
  ngOnInit(): void {
    
    if (this.global.OnboardType == "CLIENT") {
      let value = {
        Id: this.global.cfssLoginEntityId,
        Dynamictype: "Client"
      }
      this.isListorEditView.details = value;
    }
    else {
      this.isListorEditView.details = this.DynamicFormRelation;
    }
  }
  EmitChildComponent(event: DEEventEmitterBo) {
    this.CEEditList = event.isCreate;
    this.isListorEditView = event;
   
  }
}
